import upperFirst from "lodash/upperFirst";

// This function is our own edition of startCase function from lodash.
// There are some logic of the startCase that doesn't fit our need for formatting
// city names, such as stripping out dashes and dots in city names.
export const formatCityString = (city?: string): string => {
  if (!city) {
    return "";
  }
  return city.trim().split(/[ ,]+/).map(upperFirst).join(" ");
};
